// @ts-nocheck
import { Navigate } from "react-router-dom"
import { ModerationQueueClient } from "@/components/admin/moderation/ModerationQueueClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function AdminModerationPage() {
  const { user } = useAuth()
  if (!user || user.role !== "admin") return <Navigate to="/feed" replace />
  return <div className="container-app py-4"><ModerationQueueClient /></div>
}